const mutations = {
  SET_SELECTED_TYPE(state, selectedtype) {
    state.selected_type = selectedtype
  },
  SET_SELECTED_ID(state, selectedid) {
    state.selected_id = selectedid
  },
  SET_DATA_CART_RESERVATION(state, dataCartReservation) {
    state.data_cart_reservation = dataCartReservation
  },
  SET_DATA_CART_OL_TAKE_AWAY(state, dataCartTakeAway) {
    state.data_cart_take_away = dataCartTakeAway
  },
  SET_DATA_CART_DELIVERY(state, dataCartDelivery) {
    state.data_cart_delivery = dataCartDelivery
  },
  SET_DATA_CART_DINE_IN(state, dataCartDineIn) {
    state.data_cart_dinein = dataCartDineIn
  },
  SET_SELECTED_STORE(state, selectedStore) {
    state.selected_store = selectedStore
  },
  SET_SELECTED_OUTLET(state, selectedOutlet) {
    state.selected_outlet = selectedOutlet
  },
  FETCH_STORE_FAILURE(state) {
    state.selected_store = null
  },
  FETCH_OUTLET_FAILURE(state) {
    state.selected_outlet = null
  },
  FETCH_USER_DATA_FAILURE(state) {
    state.user_data = null
  },
  SET_TOKEN(state, token) {
    state.auth_data = token
  },
  TOKEN_FAILURE(state) {
    state.auth_data = null
  },
  SET_ORDER(state, orderData) {
    state.order_data = orderData
  },
  SET_HISTORY_ORDER(state, orderData) {
    state.history_order_data = orderData
  },
  SET_DATA_VERIFICATION(state, dataVerification) {
    state.data_verification = dataVerification
  },
  SET_TYPE_VERIFICATION(state, dataTypeVerification) {
    state.type_verification = dataTypeVerification
  },
  SET_QRMODE(state, qrmode) {
    state.qrmode = qrmode
  },
  SET_DISABLE_TABLE(state, value) {
    state.disable_table = value
  },
  SET_OTP_FORGET_PASSWORD(state, data) {
    state.otp_forget_password = data
  },
  SET_URL_DOMAIN(state, data) {
    state.url_domain = data
  },
  REMOVE_ERROR(state) {
    state.error_type = ''
    state.error_message = ''
    state.show_error = false
  },
  SAVE_CART_V2(state, value) {
    state.v2.cart = value
  },
  SET_ID_ORDER_V2(state, value) {
    state.v2._id = value
  },
  SAVE_LOCATION_V2(state, value) {
    state.v2.location = value
  },
  SAVE_SHIPPING_V2(state, value) {
    state.v2.shipping = value
  },
  SAVE_TABLE_V2(state, value) {
    state.v2.table = value
  },
  SAVE_DETAIL_RESERVATION_V2(state, value) {
    state.v2.detail_reservation = value
  },
  DELETE_SHIPPING_V2(state) {
    delete state.v2.shipping
  },
  DELETE_DETAIL_RESERVATION_V2(state) {
    delete state.v2.detail_reservation
  },
  SAVE_ADDITIONAL_V2(state, value) {
    state.v2.additional = value
  },
  DELETE_ADDITIONAL_V2(state) {
    delete state.v2.additional
  }
}
export default mutations
